import React from 'react';
import './GitRepositoryHeader.scss';

function GitRepositoryHeader() {
  return (<>
    <header className="git-repository-header">Git repository 👉🏻<a href="https://github.com/lorenzoVwebDev/game-of-life">Game Of Life</a></header>
  </>)
}

export default GitRepositoryHeader;